import React, { useEffect, useState, useRef} from "react";
import { connect } from "react-redux";
import moment from "moment";
import {alertActions, authActions, commonActions, bundleActions} from '../../../../store/actions'
import {commons} from "../../../../hook/common";

const BundleList = props => {
  
  return (
    <>
			<div className="list-request">
				<ul>
			{
                props.data?.length > 0 ? props.data?.map((bundleObj,index) => (
					<li key={index}>
						<dl>
							<dt>{bundleObj.packageNm}</dt>
							<dd>꾸러미 증명서 {bundleObj?.crtCnt} 종</dd>
                          {
                            bundleObj?.crtCnt !== 0 &&
                            <dd className="link"><a href="#" onClick={() => props.onBundleDetail(bundleObj)}>바로가기</a></dd>
                          }
                          {
                            bundleObj?.crtCnt === 0 &&
                          	<dd className="link">-</dd>
                          }
						</dl>
					</li>
                  ))
                  : 
                <li><div className="nodata">조회 결과가 없습니다.</div></li>
              }
				</ul>
			</div>

    </>
  )
}


const mapStateToProps = state => {
  return {
    bundleInfo: state.bundle?.bundleInfo,
  }
}

const actionCreators = {
  getBundleInfo: bundleActions.getBundleInfo,
  success: alertActions.success,
  readBundleList: bundleActions.readBundleList,
  getCommonCode: commonActions.getCommonCode,
  confirm: alertActions.confirm
}

export default connect(
  mapStateToProps,
  actionCreators
)(BundleList)
